import { connect } from 'react-redux';
import {
  removeLocationFromOrder,
  droppingAnimationFinish,
  flyingAnimationStart,
  flyingAnimationFinish,
} from '../../../redux/actions/Orders';

const mapStateToProps = state => ({
  selectedLocations: state.mainreducer.selectedLocations,
  droppingAnimation: state.mainreducer.droppingAnimation,
  flyingAnimation: state.mainreducer.flyingAnimation,
  animatedLocation: state.mainreducer.animatedLocation,
  countryCode: state.mainreducer.countryCode,
  formAuthToken: state.mainreducer.formAuthToken,
  guide: state.mainreducer.guide,
  policy: state.mainreducer.policy,
  locationList: state.mainreducer.locationList
});

const mapDispatchToProps = dispatch => ({
  removeLocationFromOrder(id) {
    dispatch(removeLocationFromOrder(id));
  },
  flyingAnimationStart() {
    dispatch(flyingAnimationStart());
  },
  flyingAnimationFinish(location) {
    dispatch(flyingAnimationFinish(location));
  },
  droppingAnimationFinish() {
    dispatch(droppingAnimationFinish());
  },
});

export default OrderFormWrapper => connect(mapStateToProps, mapDispatchToProps)(OrderFormWrapper);
